<template>
  <div>
    <div id="sidebar" :class="{ tucked: !isSidebarOpen }">
      <div class="collapsable text-center px-3">
        <div class="font-weight-bold mt-1" style="font-size: 16px">
          {{ currentUser.first_name + ' ' + currentUser.last_name | titleize }}
        </div>
        <div class="fs-14">
          {{ currentUser.job_title }}
        </div>
      </div>
      <hr>
      <b-nav vertical class="position-relative">
        <b-nav-item to="/" exact id="li-prod" @click="closeOnMobile">
          <font-awesome-icon :icon="['far', 'warehouse']" size="lg" fixed-width />
          <span class="collapsable">Producción</span>
          <font-awesome-icon :icon="['far', 'chevron-right']" pull="right" class="v-center collapsable" />
        </b-nav-item>
        <b-nav-item to="/app/prod/centro-recursos" exact id="li-centro-recursos" @click="closeOnMobile">
          <font-awesome-icon :icon="['far', 'paperclip']" size="lg" fixed-width />
          <span class="collapsable">Centro de recursos</span>
          <font-awesome-icon :icon="['far', 'chevron-right']" pull="right" class="v-center collapsable" />
        </b-nav-item>
        <b-nav-item v-if="isHrAdmin || isDev" to="/app/rrhh" exact :class="{ active: rrhhRoute }" id="li-rrhh" @click="closeOnMobile">
          <font-awesome-icon :icon="['fas', 'user-circle']" size="lg" fixed-width />
          <span class="collapsable">Usuarios</span>
          <font-awesome-icon :icon="['far', 'chevron-right']" pull="right" class="v-center collapsable" />
        </b-nav-item>
      </b-nav>
      <hr>
      <b-nav vertical class="position-relative">
        <!-- External links - ultradox links -->
        <b-dropdown size="sm" id="lis-ultx" variant="link" offset="15px" dropright toggle-class="text-decoration-none text-left px-3 text-dark fs-13" no-caret>
          <template #button-content>
            <font-awesome-icon :icon="['fas', 'file-contract']" size="lg" fixed-width />
            <span class="collapsable">Ultradox</span>
            <font-awesome-icon :icon="['far', 'chevron-right']" class="chevron-icon collapsable" />
          </template>
          <b-dropdown-item
            v-for="link in ultradoxLinks"
            :key="link.href"
            :href="link.href"
            target="_blank"
            class="fs-12 dropdown-items"
          >
            <font-awesome-icon :icon="link.icon" size="lg" fixed-width />
            <span>{{ link.label }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <b-nav-item href="https://forms.office.com/r/Uf81giyy01" target="_blank" id="li-sugerencias" @click="closeOnMobile">
          <font-awesome-icon :icon="['far', 'inbox-in']" size="lg" fixed-width />
          <span class="collapsable">Buzón Sugerencias</span>
        </b-nav-item>
      </b-nav>
      <hr>
      <b-nav vertical class="position-relative">
        <b-nav-item v-if="isDev" to="/app/noticias" id="li-noticias" @click="closeOnMobile">
          <font-awesome-icon :icon="['far', 'newspaper']" size="lg" fixed-width />
          <span class="collapsable">Noticias</span>
        </b-nav-item>
        <b-nav-item v-if="isDev" to="/app/anuncios" id="li-anuncios" @click="closeOnMobile">
          <font-awesome-icon :icon="['fas', 'bullhorn']" size="lg" fixed-width />
          <span class="collapsable">Anuncios</span>
        </b-nav-item>
        <b-nav-item v-if="isSuperAdmin" to="/app/roles" id="li-permisos" @click="closeOnMobile">
          <font-awesome-icon :icon="['fas', 'user-lock']" size="lg" fixed-width />
          <span class="collapsable">Roles & Permisos</span>
        </b-nav-item>
        <b-nav-item v-if="isDev || approvalRulesPermissions.length > 0" to="/app/aprobaciones" id="li-aprobaciones" @click="closeOnMobile">
          <font-awesome-icon :icon="['fas', 'user-check']" size="lg" fixed-width />
          <span class="collapsable">Aprobaciones</span>
        </b-nav-item>
        <b-nav-item v-if="isSuperAdmin" to="/app/contratistas" id="li-contratistas" @click="closeOnMobile">
          <font-awesome-icon :icon="['far', 'user-hard-hat']" size="lg" fixed-width />
          <span class="collapsable">Contratistas</span>
        </b-nav-item>
        <b-nav-item v-if="isSuperAdmin" to="/app/datos_externos" id="li-importar" @click="closeOnMobile">
          <font-awesome-icon :icon="['far', 'download']" size="lg" fixed-width />
          <span class="collapsable">Datos Externos</span>
        </b-nav-item>
        <b-nav-item v-if="isDev" to="/app/config" id="li-config" @click="closeOnMobile">
          <font-awesome-icon :icon="['far', 'sliders-h']" size="lg" fixed-width />
          <span class="collapsable">App Config</span>
        </b-nav-item>
      </b-nav>
    </div>
    <div id="overlay" :class="{ active: isSidebarOpen && isMobile }" @click="isSidebarOpen = false"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

// Debe coincidir con el breakpoint del @media en los estilos
const MOBILE_QUERY = '(max-width: 575.98px)'
const OPEN_BY_DEFAULT_ROUTES = ['/', '/app/rrhh']

export default {
  name: 'AppSidebar',
  data () {
    return {
      isMobile: false,
      isSidebarOpen: true,
      mql: null,
      ultradoxLinks: [
        { label: 'Factura Reserva', href: 'https://www.ultradox.com/app/1VD1sY-4kio-G9EnX2WBmrLvHa4zmiCJa', icon: ['fas', 'receipt'] },
        { label: 'Mercado Interno de Servicios', href: 'https://www.ultradox.com/app/mercadoI', icon: ['far', 'money-check-edit'] },
        { label: 'Precio Internacional', href: 'https://docs.google.com/forms/d/e/1FAIpQLSdKYBC9Po9IgQojGzq0J2VBhzVTBCgjTgLfIo_KYBy7ZTJr1g/viewform', icon: ['fas', 'hand-holding-usd'] },
        { label: 'Solicitud creación proveedor', href: 'https://www.ultradox.com/app/1uhRrIsNhiJ7NZ8gHcmQY7H-_wSjngpmx', icon: ['far', 'address-card'] },
        { label: 'Solicitud crédito cliente', href: 'https://www.ultradox.com/app/15uZo97cQRPaoYCAcqntzIH2Te1AHdvSj', icon: ['far', 'money-check-alt'] },
        { label: 'Solicitud Plazo de Pago C+8', href: 'https://www.ultradox.com/app/1UTB-FuVaM-YTCzqjOiC9kDF0tqG6PODx', icon: ['far', 'money-check-alt'] },
        { label: 'Solicitud de Fabricaciones', href: 'https://www.ultradox.com/app/SFABR2019', icon: ['far', 'garage'] },
        { label: 'Solicitud de fondos', href: 'https://www.ultradox.com/app/1uOGn0D8Mjm5vpRl9bt3J16frPENfF1D0', icon: ['far', 'money-check-edit-alt'] }
      ]
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser
    }),
    ...mapGetters([
      'isSuperAdmin',
      'isDev',
      'isHrAdmin',
      'approvalRulesPermissions'
    ]),
    rrhhRoute () {
      return this.$route.name === 'rrhh'
    }
  },
  watch: {
    '$route' () {
      this.syncWithRoute()
    },
    isSidebarOpen (open) {
      if (open) {
        this.$root.$emit('bv::hide::popover')
        this.$root.$emit('bv::disable::popover')
      } else {
        this.$root.$emit('bv::enable::popover')
      }
    }
  },
  mounted () {
    this.mql = window.matchMedia(MOBILE_QUERY)
    this.isMobile = this.mql.matches
    this.mql.addEventListener('change', this.onBreakpointChange)
    this.$root.$on('sidebar:toggle', this.toggle)
    this.syncWithRoute()
  },
  beforeDestroy () {
    this.mql.removeEventListener('change', this.onBreakpointChange)
    this.$root.$off('sidebar:toggle', this.toggle)
  },
  methods: {
    toggle () {
      this.isSidebarOpen = !this.isSidebarOpen
    },
    closeOnMobile () {
      if (this.isMobile) this.isSidebarOpen = false
    },
    onBreakpointChange (e) {
      this.isMobile = e.matches
      this.syncWithRoute()
    },
    syncWithRoute () {
      const isHomeRoute = OPEN_BY_DEFAULT_ROUTES.includes(this.$route.path)
      this.isSidebarOpen = !this.isMobile && isHomeRoute
    }
  }
}
</script>

<style scoped>
#sidebar {
  min-height: calc(100vh - 69px);
  height: 100%;
  min-width: 220px;
  max-width: 220px;
  background-color: #dae2f4;
  font-size: 13px;
  padding-top: 1em;
  pointer-events: auto;
  border-right: 1px solid #aaa;
  line-height: 2;
  transition: min-width 300ms ease, max-width 300ms ease, transform 300ms ease;
}
#sidebar.tucked {
  min-width: 60px;
  max-width: 60px;
  text-align: center;
}
#sidebar.tucked .collapsable {
  display: none;
}

#overlay {
  display: none;
  position: fixed;
  top: 61px; /* no tapa el navbar, el botón hamburguesa sigue clickeable */
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.55);
  z-index: 990;
}

/* Ultradox: que se comporte como los demás ítems */
#lis-ultx {
  display: block;
  width: 100%;
}
#lis-ultx ::v-deep .dropdown-toggle {
  display: flex;
  align-items: center;
  width: 100%;
}
.chevron-icon {
  margin-left: auto;
}

@media (max-width: 575.98px) {
  #sidebar {
    position: fixed;
    top: 61px;
    bottom: 0;
    left: 0;
    min-height: 0;
    height: auto;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 1000;
    transform: translateX(0);
  }
  #sidebar.tucked {
    min-width: 220px;
    max-width: 220px;
    transform: translateX(-100%);
  }
  #overlay.active {
    display: block;
  }
}

li:hover {
  background-color: #fafafa;
}
a {
  color: rgba(0, 0, 0, 0.87);
}
svg {
  margin-right: 8px;
}
.v-center {
  margin-top: 0.5em;
}
.active span,
.active svg {
  color: #1867c0 !important;
}
.dropdown-items :hover {
  cursor: alias;
  font-weight: bold;
}
</style>
